import { Component, EventEmitter, OnInit, Output, Input, SimpleChanges } from '@angular/core';
import { TranslateService } from "../../../../../common/variables/translate-service";
import { GlobalService } from "../../../../../common/services/global.service";
import { GlobalVariableService } from "../../../../../common/variables/global-variable";
import { GlobalFunctionService } from '../../../../../common/services/global-function.service';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { SC_Input } from 'projects/sen-app/src/app/core/common/input/SC_Input';
import { PanelGetData, PanelGetOutput } from 'projects/sen-app/src/app/core/common/api/PanelGet';
import { PanelNameGetListData, PanelNameGetListInput, PanelNameGetListOutput } from 'projects/sen-app/src/app/core/common/api/PanelNameGetList';
import { PanelManufacturerGetListData, PanelManufacturerGetListInput, PanelManufacturerGetListOutput } from 'projects/sen-app/src/app/core/common/api/PanelManufacturerGetList';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProjectGetData } from 'projects/sen-app/src/app/core/common/api/ProjectGet';
import { Global } from 'projects/sen-app/src/app/core/common/utilities/global';

@Component({
  selector: 'sen-app-sen-panel',
  templateUrl: './sen-panel.component.html',
  styleUrls: ['./sen-panel.component.scss']
})
export class SenPanelComponent implements OnInit {
  @Output() selectedPanelEmit = new EventEmitter;
  @Output() sPanel = new EventEmitter;
  @Input() action: boolean;
  @Input() validateForm: boolean;

  selectedProject$: Observable<any>;
  selectedProject: ProjectGetData;
  manufacturersList: PanelManufacturerGetListData[];
  panelList: PanelNameGetListData[];
  selectedPanelListDetail: PanelGetData;
  cellType = ['', this.translate.getLng('MOD_MONO'), this.translate.getLng('MOD_POLY'), this.translate.getLng('MOD_THIN')];
  globalFPanelUnsubscribe: Subscription;
  unsubscribeSelectedProject: Subscription;
  form: FormGroup;
  projectPanel: boolean;
  projectPanelDisable: boolean = true;
  convertToLocalNumber: any = Global.convertToLocalNumber;
  constructor(public translate: TranslateService,
    public globalF: GlobalFunctionService,
    private store: Store<any>,
    private formBuilder: FormBuilder,
    public global: GlobalVariableService,
    public globalService: GlobalService) {
    this.selectedProject$ = this.store.select(state => { return state.appData.selectedProject });
    this.unsubscribeSelectedProject = this.selectedProject$.subscribe(data => {
      this.selectedProject = data;
    });
    this.form = this.formBuilder.group({
      selectedManufacturer: new FormControl(null, Validators.required),
      selectedPanelID: new FormControl(null, Validators.required)
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.validateForm && !changes.validateForm.isFirstChange()) {
      this.form.markAllAsTouched();
    }
  }

  ngOnInit(): void {
    this.getManufactureList();
  }

  ngOnDestroy() {
    SC_Input.sPlanDetails.projectPanel = this.projectPanel;
    if (this.globalFPanelUnsubscribe) this.globalFPanelUnsubscribe.unsubscribe();
    if (this.unsubscribeSelectedProject) this.unsubscribeSelectedProject.unsubscribe();
  }

  setUserPanelSelected() {
    SC_Input.userSenPanelSelected = this.projectPanel;
  }

  setProjectPanel(id: number) {
    if (SC_Input.userSenPanelSelected) {
      this.projectPanel = true;
      this.projectPanelDisable = false;
    } else if (id == this.selectedProject.panelID || !this.selectedProject.roofPlans.length || (this.selectedProject.roofPlans.length == 1 && SC_Input.sPlan)) {
      this.projectPanel = true;
      this.projectPanelDisable = true;
    } else {
      this.projectPanel = false;
      this.projectPanelDisable = false;
    }
  }

  getManufactureList() {
    const qParam: PanelManufacturerGetListInput = {
      cmd: this.global.PanelManufacturerGetList
    };
    this.globalService.getData(qParam).subscribe((data: PanelManufacturerGetListOutput) => {
      try {
        if (data.ok.data.manufacturers) {
          this.manufacturersList = data.ok.data.manufacturers;
          this.selectedPanelEmit.emit(false);
          if (SC_Input.sPanel?.senItemID) {
            this.form.get('selectedManufacturer')?.setValue(SC_Input.sPanel.manufacturer);
            this.form.get('selectedPanelID')?.setValue(SC_Input.sPanel.id);
            this.selectedPanelListDetail = SC_Input.sPanel;
            this.sPanel.emit(this.selectedPanelListDetail);
            this.getPanelList(SC_Input.sPanel.manufacturer, true);
            this.setProjectPanel(this.selectedPanelListDetail.id)
          }
        }
      } catch { }
    });
  }

  getPanelList(manufacturer: string, emit: boolean) {
    const qParam: PanelNameGetListInput = {
      cmd: this.global.PanelNameGetList,
      manufacturer: manufacturer
    };
    this.globalService.getData(qParam).subscribe((data: PanelNameGetListOutput) => {
      try {
        if (data.ok.data.panels) {
          this.panelList = data.ok.data.panels;
          this.selectedPanelEmit.emit(emit);
        }
      } catch { }
    });
  }

  getPanelDetail(panelID: number) {
    this.globalFPanelUnsubscribe = this.globalF.getPanelDetail(panelID).subscribe((data: PanelGetOutput) => {
      try {
        if (data.ok.data) {
          this.selectedPanelListDetail = data.ok.data;
          this.selectedPanelListDetail.stock = data.ok.data.stock;
          this.selectedPanelListDetail.id = panelID;
          this.selectedPanelEmit.emit(true);
          this.sPanel.emit(this.selectedPanelListDetail);
          SC_Input.userSenPanelSelected = false;
          this.setProjectPanel(panelID);
        }
      } catch { }
    });
  }
}
